/* global Ad, google, googleMapsLoadedForSimpleForm */

import configureFetchPlaces from '@PROJECT_ROOT/assets/shared/js/placesFetch';
import configureGetPrivateFilterForm from '@PROJECT_ROOT/assets/desktop/js/search/privateFilterForm';
import getFormatGooglePredictionsForAutocomplete from '@PROJECT_ROOT/assets/desktop/js/search/formatGoogleResults';
import isGoogleLocationId from '@PROJECT_ROOT/assets/shared/js/PrivateAccommodation/googleLocationId';
import makeFetchExternalAutocomplete from '@PROJECT_ROOT/assets/shared/js/externalAutocomplete';
import makeGetPlaceInfo from '@PROJECT_ROOT/assets/desktop/js/search/mapsearch/GooglePlaceInfo';

const filterFormHandler = configureGetPrivateFilterForm()();

/**
 * @param {object} state PHP varijable
 */
export default function initLocation(state) {
    initEvents(state);
    toggleRadiusSelection();
}

function initEvents(state) {
    initLocationAutocomplete(state);

    document.getElementById('SearchPrivateFilterForm_location').addEventListener('change', locationChangeEvent);
}

/**
 * Polje 'pl_r' (radijus oko lokacije) omogućiti samo ako je lokacija unešena, i to mjesto (ne rivijera, regija, itd.).
 * Defaultno postavlja odabir na 20 km.
 */
function toggleRadiusSelection() {
    const locationId = document.getElementById('SearchPrivateFilterForm_location_id').value;
    if (locationId.substr(0, 3) === 'pl-' || isGoogleLocationId(locationId)) {
        document.getElementById('privateSearchPlaceRadiusSelect').classList.remove('disabled');
        document.getElementById('SearchPrivateFilterForm_pl_r').disabled = false;
        document.getElementById('SearchPrivateFilterForm_pl_r').value = '20';
    } else {
        document.getElementById('privateSearchPlaceRadiusSelect').classList.add('disabled');
        document.getElementById('SearchPrivateFilterForm_pl_r').disabled = true;
        document.getElementById('SearchPrivateFilterForm_pl_r').value = '0';
    }
}

function initLocationAutocomplete(state) {
    let googleAutocompleteService;
    let getPlaceInfo = () => {};

    googleMapsLoadedForSimpleForm.then(() => {
        googleAutocompleteService = new google.maps.places.AutocompleteService();

        getPlaceInfo = makeGetPlaceInfo(
            new google.maps.places.PlacesService(document.createElement('div')),
            google.maps.places.PlacesServiceStatus,
        );

        setLocation(
            document.getElementById('SearchPrivateFilterForm_location').value,
            document.getElementById('SearchPrivateFilterForm_location_id').value,
        );
    });

    initAutocomplete();

    /**
     * Postavlja naziv, id i koordinate mape za Google lokaciju.
     * Ukoliko lokacija nije Google mjesto, koordinate mape se brišu.
     *
     * @param {string} locationId Identifikator lokacije (Adriatic ili Google); npr. 'google_1234'
     */
    function setLocationToGooglePlace(locationId) {
        const googlePlaceFound = (name, location, viewport) => {
            setFormLocationAndLocationId(name, locationId);
            filterFormHandler.setFilterMapCoordinates(viewport);
        };
        const googlePlaceNotFound = () => {
            clearMapCoordinatesIfOurLocationSearchOrEmpty(locationId);
        };

        getPlaceInfo(locationId, googlePlaceFound, googlePlaceNotFound);
    }

    function setLocation(name, id) {
        if (isGoogleLocationId(id)) {
            setLocationToGooglePlace(id);
        } else {
            setFormLocationAndLocationId(name, id);
            clearMapCoordinatesIfOurLocationSearchOrEmpty(id);
        }
        toggleRadiusSelection();
    }

    function setFormLocationAndLocationId(name, id) {
        // Mora biti jQuery, u suprotnom se locationId izbriše iz forme
        $('#SearchPrivateFilterForm_location').data('latestLocation', name);

        document.getElementById('SearchPrivateFilterForm_location').value = name;

        if (typeof id !== 'undefined') {
            document.getElementById('SearchPrivateFilterForm_location_id').value = id;
        }
    }

    function initAutocomplete() {
        const $formLocation = $('#SearchPrivateFilterForm_location');
        const latestLocation = { id: $formLocation.val() };

        let userSelectedAnItem = false;
        let firstItem = null;

        $formLocation.placescomplete({
            source: setupAutocomplete(),
            select(e, ui) {
                userSelectedAnItem = true;
                setLocation(ui.item.value, ui.item.id);
            },
            search() {
                $('.ui-autocomplete').hide();
            },
            autoFocus: true,
            // Ovi eventovi su bitni za automatski odabir prvog elementa autocomplete popisa u slučaju kada je
            // korisnik zatvorio popis bez da je išta odabrao. Redoslijed pokretanja handlera je:
            // 1. response,
            // 2. open,
            // 3. select (neće se pokrenuti ako korisnik nije ništa odabrao),
            // 4. close
            close() {
                // Ako korisnik na zatvaranje izbornika nije ništa odabrao, uzimamo prvi item iz liste od zadnje
                // pretrage
                if (!userSelectedAnItem) {
                    // firstItem nikad neće biti null jer se ovaj handler ne poziva u slučaju kada nema ništa u
                    // autocomplete prozoru
                    setLocation(firstItem.value, firstItem.id);
                }
            },
            delay: 500,
            open() {
                userSelectedAnItem = false;
            },
            response(event, ui) {
                firstItem = ui.content.length > 0 ? ui.content[0].items[0] : null;
            },
        });

        Ad.Autocomplete.initCompleteList('#SearchPrivateFilterForm_location', latestLocation);
    }

    function setupAutocomplete() {
        const fetchGoogleAutocomplete = makeFetchExternalAutocomplete(() => googleAutocompleteService);
        const formatGooglePredictions = getFormatGooglePredictionsForAutocomplete(state.poweredByGoogleIcon);
        const fetchPlacesForAutocomplete = configureFetchPlaces(
            $.post,
            state.placesAutocompleteUrl,
            fetchGoogleAutocomplete,
            formatGooglePredictions,
        );

        return fetchPlacesForAutocomplete;
    }
}

function clearMapCoordinatesIfOurLocationSearchOrEmpty(locationId) {
    if ((!isGoogleLocationId(locationId) && locationId.length > 0) || locationId.length === 0) {
        filterFormHandler.clearMapCoordinatesFilter();
    }
}

/**
 * Pri promjeni lokacije:
 *     - enable/disable radijusa
 *     - brisanje koordinata ako lokacija nije Google-ova
 */
function locationChangeEvent() {
    toggleRadiusSelection();

    const locationId = document.getElementById('SearchPrivateFilterForm_location_id').value;
    clearMapCoordinatesIfOurLocationSearchOrEmpty(locationId);
}
